<template>
	<div style="padding: 0px;">
		<div>
			<div style="min-width: 120px;float: right;margin-right: 20px;">
				<el-button type="primary" icon="el-icon-plus" @click="addLocPoint">添加</el-button>
			</div>
		</div>
		<div style="margin-top: 10px;">
			<el-table :data="sysLocPointsList"  style="width: 100%"  max-height="500">
			    <el-table-column fixed="left" prop="type" label="类型" width="150" align="center">
					<template slot-scope="scope">
						<el-tag v-if="'dev' == scope.row.type" type="success">设备点位</el-tag>
						<el-tag v-else type="info">计算点位</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="locname" label="所属位置" align="center"></el-table-column>
				<el-table-column prop="devname" label="设备名称" align="center"></el-table-column>
			    <el-table-column prop="pointname" label="点位名称" align="center"></el-table-column>
				<el-table-column prop="unit" label="单位" align="center"></el-table-column>
				<el-table-column prop="iconurl" label="图标" align="center"></el-table-column>
				<el-table-column prop="idx" label="排序" align="center"></el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="180" align="center">
					<template slot-scope="scope">
						<a @click="deleteLocPoint(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
							<i class="el-icon-Stall">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="locPointTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashRelData" append-to-body :destroy-on-close="true" title="添加关联点位" width="70%" :visible.sync="addrelshow">
			<AddLocPoint @needRelRefrash="needRelRefrash" :add="true" :selectedloc="syslocinfo" ></AddLocPoint>
		</el-dialog>
	</div>
</template>

<script> 
	import { queryLocRelPointsByPage,deleteSLocationRelPoint } from '/static/apiUrl.js'
	import AddLocPoint from './addlocpoint'
	export default {
		name : 'LocPoint',
		data() {
			return {
				syslocinfo : {
					id: "",
					name: "",
					parentid : '',
					orgid: "",
					typeid: "",
					idx : 0
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				locPointTotal : 0,
				sysLocPointsList : [],
				addrelshow : false,
				
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		components: {
			AddLocPoint,
		},
		props: {
			selectedloc: {
				type: Object,
				required: true
			},
		},
		watch: {
			selectedloc: {
				immediate: true,
				handler(newVal) {
					if(newVal != null){
						this.syslocinfo.id = newVal.id
						this.syslocinfo.name = newVal.name
						this.syslocinfo.parentid = newVal.parentid
						this.syslocinfo.orgid = newVal.orgid
						this.syslocinfo.typeid = newVal.typeid
						this.syslocinfo.idx = newVal.idx
						this.queryLocPointList()
					}else{
						this.syslocinfo.id = ""
						this.syslocinfo.name = ""
						this.syslocinfo.parentid = ""
						this.syslocinfo.orgid = ""
						this.syslocinfo.typeid = ""
						this.syslocinfo.idx = 0
					}
				}
			},
		},
		methods: {
			initData(){
				
			},
			handleSizeChange(val){
				this.param.pagenum = val;
				this.queryLocPointList()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryLocPointList()
			},
			queryLocPointList(){
				this.sysLocPointsList = []
				queryLocRelPointsByPage({
					locid : this.syslocinfo.id,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					if(0 == res.code){
						this.locPointTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.sysLocPointsList.push(set)
						})
					}
				})
			},
			deleteLocPoint(idx,row){
				this.$confirm('此操作将删除位置绑定的点位 '+this.sysLocPointsList[idx].pointname+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteSLocationRelPoint({
						id : this.sysLocPointsList[idx].id
					}).then(res => {
						if(0 == res.code){
							this.queryLocPointList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			addLocPoint(){
				this.addrelshow = true
			},
			needRelRefrash(val,isshow){
				this.editok = val
				this.addrelshow = isshow
			},
			refrashRelData() {
				if(this.editok){
					this.queryLocPointList()
				}
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>